import { useEffect } from "react";
import CustomDialog from "../../../components/common/dialogs/CustomDialog";
import { useDesactivarBlMutation } from "../../../services/bl-export/BLExportService";

interface props {
  idBl: number;
  isOpen: boolean;
  onClose: () => void;
  callback: () => void;
}

const ModalDisableBl = ({ idBl, isOpen, onClose, callback }: props) => {
  const [desactivar, { isLoading, isSuccess, isError, reset }] =
    useDesactivarBlMutation();

  const handleSubmit = () => {
    desactivar({
      id_bl: idBl,
    });
  };

  const handleClose = () => {
    onClose();
    setTimeout(() => reset(), 200);
  };

  useEffect(() => {
    if (isSuccess === true) {
      callback();
      return;
    }
  }, [isSuccess, callback]);

  return (
    <div>
      <CustomDialog
        maxWidth="xs"
        isOpen={isOpen}
        handleClose={handleClose}
        title="Desactivar BL"
        subtitle="¿Esta séguro de desactivar el BL seleccionado?"
        textButton="Sí, Desactivar"
        errorMessage="No se ha podido desactivar el BL"
        successMessage="Bl desactivado correctamente"
        handleSubmit={handleSubmit}
        isError={isError}
        isSuccess={isSuccess}
        isLoading={isLoading}
      />
    </div>
  );
};

export default ModalDisableBl;
